import classNames from 'classnames';
import React from 'react';

import styles from './View.module.scss';

interface IProps {
  flexGrow?: boolean;
  // Taken from React's own CSSProperties rather than csstype directly: csstype
  // v3 renamed these types, and going through React keeps them in step with
  // whatever version @types/react depends on.
  flexDirection?: React.CSSProperties['flexDirection'];
  alignItems?: React.CSSProperties['alignItems'];
  style?: React.CSSProperties;
  className?: string;
  // React 18's types dropped the implicit `children` from React.FC.
  children?: React.ReactNode;
}

const View: React.FC<IProps> = (props) => {
  const viewStyles: React.CSSProperties = {};

  if (props.flexDirection) {
    viewStyles.flexDirection = props.flexDirection;
  }

  if (props.alignItems) {
    viewStyles.alignItems = props.alignItems;
  }

  return (
    <div
      className={classNames(styles.root, {
        [styles.flexGrow]: props.flexGrow,
      }, props.className)}
      style={{ ...props.style, ...viewStyles }}
    >
      {props.children}
    </div>
  );
};

export default View;
